<template>
  <div class="cc_page">
    <div class="m_user_info">
       <div class="m_score">
         <div class="m_integral" >
           <div>
           <span>可用</span>
             <span class="num">{{scoreUserInfo.totalScore*1-scoreUserInfo.usedScore*1}}</span>
             <span>券币 </span>
           </div>
           <span>（等级：{{scoreUserInfo.degreeID}}）</span>
         </div>
       </div>
       <div class="m_sign">
       <!-- <form bindsubmit="formSubmit">
           <button formType="submit" id="sign">签到</button>
       </form> -->
     <div class="m_integral" >
         <div>
           <span>总</span>
           <span class="num">{{scoreUserInfo.totalScore}}</span>
           <span>券币</span>
         </div>
         <span>（已兑换{{scoreUserInfo.usedScore}}券币）</span>
       </div>
       </div>

     </div>
     <coinsCenterList v-if="userInfo.openId" :openID = "userInfo.openId"></coinsCenterList>
   </div>

</template>
<script type = "span/ecamscript-6">
  import CoinsCenterList from './coinsCenterList'
  export default {
    name:"coinsCenter",
    data(){
      return{
        paperDiscuss:'[]',
        userInfo:JSON.parse(sessionStorage.userInfo)
      }
    },
    methods:{
      // login () {
      //
      //   this.url = "getDiscuss.php"
      //   console.log(this.url)
      //   this.$ajax.autoService
      //       .login(this.url)
      //       .then((res) => {
      //         paperDiscuss = res.data[0]
      //       //   this.paperDiscuss = this.paperDiscuss.concat(res.data.map(function (item) {
      //       //   //item.createtime = getDateDiff(new Date(item.createtime.replace(/-/g, '/')));
      //       //   // if (item.picUrls && item.picUrls != '') {
      //       //   //   item.pics = item.picUrls.split(',')
      //       //   // }
      //       //   //item.menuOpen = false
      //       //   return item
      //       // }));
      //       // this.paperWelfares = this.paperWelfares[0]
      //
      //
      //       }, (res) => {
      //           console.log("error")
      //           //this.REQUIRE = true;
      //       })
      //  },
    },
    components:{
      'coinsCenterList':CoinsCenterList
    },
    computed:{
      scoreUserInfo: function() {
        return this.$store.state.scoreUserInfo
      },
    }
  }
</script>
<style lang="stylus">
  .cc_page
    .m_user_info
      display:flex
      justify-content: space-between
      padding:50px 0
      background:linear-gradient(to bottom,#f40,#f80)
      text-align:center
      color:#fff
      .m_score
        box-sizing: border-box
        width: 50%
      .m_sign
        box-sizing: border-box
        width: 50%
        border-left: 2px solid #fff
        /*px*/
</style>



// WEBPACK FOOTER //
// src/components/userCenter/coinsCenter.vue